import { IconicButton } from "@nulogy/components";
import { maxZoomLevel } from "config/zoomConfig";
import React from "react";
import { useTheme } from "styled-components";

export default function ZoomLevelSelector({ disabled, onZoomLevelChange, zoomLevel }) {
  const minZoom = 0;
  const theme = useTheme();

  return (
    <>
      <IconicButton
        disabled={zoomLevel === maxZoomLevel || disabled}
        icon=""
        onClick={() => onZoomLevelChange(zoomLevel + 1)}
      >
        <svg
          fill={theme.colors.darkBlue}
          height="24px"
          style={{ marginLeft: "-28px" }}
          viewBox="0 -960 960 960"
          width="24px"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M200-440v-80h560v80H200Z" />
        </svg>
      </IconicButton>

      <IconicButton
        disabled={zoomLevel === minZoom || disabled}
        icon="add"
        onClick={() => onZoomLevelChange(zoomLevel - 1)}
      />
    </>
  );
}
